import { CustomTable } from "@/components/Tables/CustomTable"
import { useCustomQuery } from "@/hooks/useCustomQuery"
import AddCashDenominationModal from "@/pages/cash-denominations/AddCashDenominationModal"
import { columns } from "@/pages/cash-denominations/Columns"
import { useState } from "react"
import { CrudProvider, useCrudContext } from "@/context/crudContext"
import Breadcrumbs from "@/components/Breadcrumbs/Breadcrumbs"

export default function CashDenominationList() {
  const breadcrumbs = [
    { label: "Dashboard", url: "/" },
    { label: "Cash Denomination" },
  ]
  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcrumb-card">
        <h5>Cash Denomination</h5>

        <Breadcrumbs breadcrumbs={breadcrumbs} />
      </div>

      <CrudProvider>
        <CashDenominationTable />
      </CrudProvider>
    </>
  )
}

function CashDenominationTable() {
  const [editData, setEditData] = useState(null)
  const {
    setOpenDialog,
    openDialog,
    setSelectedRow: setModelSelectedRow,
  } = useCrudContext()
  const onEdit = (data) => {
    setEditData(data)
    console.log("editdata", editData)
    setOpenDialog(true)
  }
  return (
    <>
      <CustomTable
        label="Cash Sessions"
        columns={columns}
        addBtn={true}
        apiPath="cash"
        showDelete={false}
        onEdit={onEdit}
      />

      {(openDialog || editData) && (
        <AddCashDenominationModal
          editData={editData}
          onClose={() => setEditData(null)}
        />
      )}
    </>
  )
}
